"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default() {
  return {
    collapsed: false,
    items: [1, 2, 3],
    itemsById: {
      1: {
        id: 1,
        link: '',
        img: '',
        alt: '',
        text: '<img src="https://placehold.it/50x30" alt="" /><strong>FREE SHIPPING ON ORDER OVER $150+</strong>',
        collapsed: false,
        type: 'text'
      },
      2: {
        id: 2,
        link: '',
        img: '',
        alt: '',
        text: '<img src="https://placehold.it/50x30" alt="" /><strong>DISCOUNT UP TO 30% FOR GOLD MEMBER</strong>',
        collapsed: true,
        type: 'text'
      },
      3: {
        id: 3,
        link: '',
        img: '',
        alt: '',
        text: '<img src="https://placehold.it/50x30" alt="" /><strong>12PM EST - EXPRESS SHIPPING CUT OFF</strong>',
        collapsed: true,
        type: 'text'
      }
    },
    itemNextId: 4
  };
}